import React, { FunctionComponent, ReactNode, KeyboardEvent, SyntheticEvent } from 'react';
import classNames from 'classnames';

import styles from './main.scss';

type TabsProps = {
    activeTabIndex: number;
    activeTabClassName?: string;
    containerClassName?: string;
    collapsed?: boolean;
    fontBold?: boolean;
    onKeyDownTab?: (arg0: number) => (arg0: KeyboardEvent<HTMLAnchorElement>) => void;
    onSelectTab?: (arg0: number) => (arg0: SyntheticEvent<HTMLAnchorElement>) => void;
    tabClassName?: string;
    tabLabels?: string[];
};

export const Tabs: FunctionComponent<TabsProps> = props => {
    const {
        activeTabIndex,
        activeTabClassName,
        collapsed,
        containerClassName,
        fontBold = false,
        onKeyDownTab,
        onSelectTab,
        tabClassName,
        children,
        tabLabels,
    } = props;

    // Property 'map' does not exist on type '{} | string[] | ReactNodeArray'.
    //  Property 'map' does not exist on type '{}'.
    // let labels: LabelTabsProps['tabLabels'] | ReactNode = [];
    let labels: $TSFixMe = [];
    if (children) {
        const _children = React.Children.toArray(props.children);
        if (_children.length) {
            labels = _children;
        }
    } else if (tabLabels) {
        if (process.env.NODE_ENV === 'development') {
            console.warn(
                "dibs-elements | Tabs | property 'tabLabels' is deprecated. Pass in children instead."
            );
        }
        labels = tabLabels;
    }

    return (
        <ul
            className={classNames(styles.tabs, containerClassName, {
                [styles.collapsed]: collapsed,
                [styles.fontBold]: fontBold,
            })}
        >
            {labels.map((tab: ReactNode | string, index: number) => {
                const active = activeTabIndex === index;
                const finalTabClassName = classNames(
                    styles.tab,
                    {
                        [classNames(styles.active, activeTabClassName)]: active,
                    },
                    tabClassName
                );
                return (
                    <li
                        className={finalTabClassName}
                        key={`tab-${index}`}
                        role="tablist"
                        data-tn={`tab-${index}`}
                    >
                        <a
                            className={styles.tabItem}
                            aria-selected={active ? 'true' : 'false'}
                            onClick={onSelectTab ? onSelectTab(index) : undefined}
                            onKeyDown={onKeyDownTab ? onKeyDownTab(index) : undefined}
                            onFocus={onSelectTab ? onSelectTab(index) : undefined}
                            role="tab"
                        >
                            {tab}
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};
